import { UserContext } from 'contexts/ConfigContext';
import { useApplyFilterMutation } from 'hooks/general/useApplyFilterMutation';
import { useFetchApplyFilterWithError } from 'hooks/Filter/useFetchApplyFilterWithError';
import _, { isNull } from 'lodash';
import { getApplyFilterObject, getFilteredApplyFilterObject } from 'parser/filterParser';
import React, { useContext, useEffect, useRef } from 'react';
import { getConfig } from 'utils/helperMethods';
import { useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { trackEventMixpanel } from 'utils/mixpanel';
import { GLOBAL_FILTER_APPLY_CLICKED } from 'utils/mixpanelEventNames';

export function callId(applyFilterButtonObject: any, applyFilterMutate: Function) {
    let tempApplyFilterButtonObject: any = {};
    Object.keys(applyFilterButtonObject).forEach(function (dim) {
        tempApplyFilterButtonObject[dim] = JSON.stringify(applyFilterButtonObject[dim]);
    });
    applyFilterMutate({
        variables: tempApplyFilterButtonObject,
    });
}
interface props {
    setIdForRestOfComponent: any;
    applyFilterObject: any;
    applyFilterButtonObject: any;
    setIdForRestOfComponentLoading: any;
    setIdForRestOfComponentFilterB: Function;
    setFilterNullError: Function;
    allCheckedAttribute: any;
    setFilterBLoading: Function;
    setAttributeTypeExpandClose: Function;
}

export function createFilterB(
    applyFilterObject: any,
    promoScoreCardConfig: any,
    getFilteredApplyFilterObject: any,
    applyFilterMutate: any,
    callId: Function,
) {
    let copyOfApplyFilter = _.cloneDeep(applyFilterObject);
    let FilterB = getFilteredApplyFilterObject(copyOfApplyFilter, promoScoreCardConfig.listFor);

    let filterBObj = getApplyFilterObject(FilterB);
    callId(filterBObj, applyFilterMutate);
}
export const antIcon = <LoadingOutlined style={{ fontSize: 18, color: 'white' }} spin />;

export default function FilterApplyButton({
    setIdForRestOfComponent,
    applyFilterObject,
    applyFilterButtonObject,
    setIdForRestOfComponentLoading,
    setIdForRestOfComponentFilterB,
    setFilterNullError,
    allCheckedAttribute,
    setFilterBLoading,
    setAttributeTypeExpandClose,
}: props) {
    let route = useLocation();
    const { applyFilterMutate, loading } = useFetchApplyFilterWithError({ onComplete: onApplyFilterComplete });
    const { applyFilterMutate: applyFilterForFilterB, loading: filterBLoading } = useApplyFilterMutation({
        onComplete: onApplyFilterCompleteFilterB,
    });
    const { appConfig } = useContext(UserContext);
    const promoScoreCardConfig = getConfig('promoScoreCard', appConfig);

    useEffect(() => {
        setIdForRestOfComponentLoading(loading);
    }, [loading]);

    useEffect(() => {
        setFilterBLoading(filterBLoading);
    }, [filterBLoading]);

    //onclick of apply button
    function onClickOfApplyFilter(applyFilterObject: any, applyFilterButtonObject: any) {
        applyFilterButtonObject.current = getApplyFilterObject(applyFilterObject);
        callId(applyFilterButtonObject.current, applyFilterMutate);
        //  if (route.pathname.includes('promo-score-card')) {
        createFilterB(
            applyFilterObject,
            promoScoreCardConfig,
            getFilteredApplyFilterObject,
            applyFilterForFilterB,
            callId,
        );
        //  }
        setAttributeTypeExpandClose('');
    }
    //remove the error from response of apply filter call
    function removeErrorFromPayload(payload: any) {
        let copyOfPayload = _.cloneDeep(payload);
        for (let dim in copyOfPayload) {
            for (let dimLevelData in copyOfPayload[dim]) {
                if (dimLevelData == 'errorDesc') {
                    delete copyOfPayload[dim][dimLevelData];
                }
            }
        }
        return copyOfPayload;
    }
    //find the error if there in the response
    function errorFinderInPayload(payload: any, setFilterNullError: Function) {
        let hasError = true;
        let hasErrorForAttributeName = true;
        for (let dimension in payload) {
            const levelData = payload[dimension];
            // if (!levelData.ids.length) {
            //     hasError = hasError && true;
            // } else
            if (levelData.errorDesc?.length) {
                hasError = hasError && true;
            } else {
                hasError = hasError && false;
            }
        }
        for (let attr in allCheckedAttribute) {
            const attrTypeObj = allCheckedAttribute[attr];
            if (Object.keys(attrTypeObj).length) {
                hasErrorForAttributeName = hasErrorForAttributeName && false;
            }
        }
        let final = hasError || hasErrorForAttributeName;
        setFilterNullError(final);
    }
    //oncomplete of the apply filter
    function onApplyFilterComplete(payload: any) {
        errorFinderInPayload(payload, setFilterNullError);
        setIdForRestOfComponent(removeErrorFromPayload(payload));
    }
    //set filterB when user on promo score card
    function onApplyFilterCompleteFilterB(payload: any) {
        setIdForRestOfComponentFilterB(payload);
    }

    return (
        <div
            className="w-36 py-2 absolute bottom-4 left-[50%] translate-x-[-50%] bg-purpleFont flex justify-center items-center rounded m-auto cursor-pointer mt-3"
            onClick={() => {
                onClickOfApplyFilter(applyFilterObject, applyFilterButtonObject);

                //MIXPANEL EVENT
                trackEventMixpanel(GLOBAL_FILTER_APPLY_CLICKED);
            }}
        >
            <span className="text-white font-bold font-xs text-center flex justify-center items-center">
                {loading ? <Spin indicator={antIcon} /> : <span>Apply</span>}
            </span>
        </div>
    );
}
